import $ from 'jquery';
import 'babel-polyfill';
import objectFitImages from 'object-fit-images';

import './../scss/main.scss';
import './../scss/ckeditor.scss';
import './promo-video';
import './lottie-animations';

// Control megaMenu, header and market list behavior
import './header';
import './menu-behavior';
import './responsive-menu';
import './segment-sticky-menu';
import './sub-menu-sticky';
import './market-selector-flags';
import './ajax-process';

// Quick contact
import './quick-contact';

// Product group behavior
import './product-group';
import './product-list-filter';

import './side-menu';
import './side-menu-mobile';

$(() => {
  objectFitImages();
});

